import { connect } from 'react-redux'
import { withCookies } from 'react-cookie'

import FilterPanel from '../../components/FilterPanel/FilterPanel'
import { hideFilterModal, toggleFilterPanelStatic } from '../../redux/product/product'
import { loadingStart } from '../../redux/application/application'

const mapStateToProps = state => ({
  categoryName: state.category.categoryName,
  isPlp: state.category.isPlp,
  isPlpPlus: state.category.isPlpPlus,
  isPlpPlusDescendant: state.category.isPlpPlusDescendant,
  isClearance: state.application.isClearance,
  isCannedSearch: state.product.isCannedSearch,
  ancestors: state.category.ancestors,
  children: state.category.children,
  siblings: state.category.siblings,
  subcategories: state.category.subcategories,
  categoryId: state.category.categoryId,
  topLevelCategoryId: state.category.topLevelCategoryId,
  filters: state.product.filters,
  appliedFilters: state.product.appliedFilters,
  appliedFiltersOrder: state.product.appliedFiltersOrder,
  filterResetCount: state.product.filterResetCount,
  filterModalVisible: state.product.filterModalVisible,
  filterPanelStatic: state.product.filterPanelStatic,
  searchTerm: state.product.searchTerm,
  ratingFilterApplied: state.product.ratingFilterApplied,
  numberOfResults: state.product.numberOfResults,
  categoryMatch: state.product.categoryMatch,
  brandSuggestions: state.product.brandSuggestions,
  templateType: state.category.templateType,
  displayErrorModal: state.application.displayErrorModal,
  loader: state.application.loader,
  pageType: state.application.pageType
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    hideFilterModal: () => dispatch(hideFilterModal()),
    toggleFilterPanelStatic: payload => dispatch(toggleFilterPanelStatic(payload)),
    loadingStart: () => dispatch(loadingStart())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(FilterPanel))
